<template>
    <div>
    <div style="display: none;" class="top-header-mobile p-2 d-flex align-items-center justify-content-between">
     <div class="logoTop-mob">
     <img src="../../../../static/fxView/images/logo.png">
     </div>
     <div class="mobTop-menu">
       <div class="navbar-light">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
       </button>
      </div>
     </div>
    </div>
    <div class="top-sidebar-header d-flex align-items-center justify-content-between border-bottom py-0 mb-3">
        <div class="d-flex align-items-center">
            <h4>{{nameFunction(pageName)}}</h4>
        </div> 
        <!----------msz panel------------->
        <!--<p v-if="msz != ''" class="mszFade" :class="(msz_type == 'success')? 'alert alert-success' : 'error'">
            {{message}}
            <feather type="x"  v-if="message != ''" @click="message = ''"></feather>
        </p>-->
        <!-------------------------------->
        <div class="d-flex align-items-center justify-content-end">
            <router-link class="common_btn minAotu" :class="parseInt(get_user.profile.gAuthenticatorEnabled) == 1 ? 'enabled' : ''" to="/enable-2fa"> <span v-html="parseInt(get_user.profile.gAuthenticatorEnabled) == 1 ? 'Disable ' : 'Enable '"> </span> 2FA  </router-link>
            <div class="dropdown headerNot-mob border-left">
                <button class="btn dropdown-toggle pr-5" id="menu1" type="button" data-toggle="dropdown">
                <div class="user-header d-flex align-items-center">
                    {{get_user.username.charAt(0)}}
                </div> 
                <span class="caret"></span></button>
                <ul class="dropdown-menu user p-0" role="menu" aria-labelledby="menu1">
                    <!-- <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Notification</a></li>
                    <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Security</a></li> -->
                    <li role="presentation" class="divider"></li>
                    <li role="presentation"><a role="menuitem" tabindex="-1" href="#" @click="logout()">Logout</a></li>
                    <li class="nav_moblinks">
                        <router-link to="/change-password">
                            <span class="hide-menu">Change Password</span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import * as types from '@/types'
    import { mapActions } from 'vuex' 
    export default {
        data() {
            return { message : '' }
        },
        mixins: [fxViewMixins],  
        props:['pageName'],
        computed:{
            /*fdeOut(){
                console.log(this.msz)
                this.message = this.msz
                if(this.message != ''){
                    setTimeout(function(){$('.mszFade').fadeOut();}, 6000);
                }
            }*/
        },
        methods:{
			nameFunction(getData){
				let nameString = "" ;
				let name_array = getData.split('-');
				for(let i=0 ; i<=name_array.length -1 ; i++){
					nameString = nameString +' '+name_array[i]
					
					if(i == name_array.length -1){
						return nameString;
					}
				}
			},
            ...mapActions({
                _runLogout: types.RUN_USER_LOGOUT
            }),
            logout(){
                const r = this.$router
                this._runLogout({
                    router: r,
                    parameter: this
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/header.vue